import {useEffect} from 'react';
import useSubscription from '../../../hooks/useSubscription';
import MemberShipPlanDetails from './MemberShipPlanDetails';

const SelectMembership = () => {
  const {callSubscription, subscriptionResponse} = useSubscription();

  useEffect(() => {
    callSubscription();
  }, []);

  return (
    <>
      <div className="md:min-w-[486px] md:max-w-[486px] px-4 md:mx-auto relative z-[2]">
        {subscriptionResponse && (
          <MemberShipPlanDetails trialPeriodDays={subscriptionResponse?.trialPeriodDays} />
        )}
      </div>
    </>
  );
};

export default SelectMembership;
